var __default__ = {root:'m_71ac47fc'};
export default __default__;